export default class formConfig {
  // 报建类项目登记 建委/投资项目信息
  static projectInformation() {
    return [
      {
        title: "项目信息导入",
        name: "1",
        icon: "",
        tipsList: [
          { text: "（1）“登录号”和“密码”是企业在“湖北省建筑市场监督与诚信一体化平台”上进行项目登记，获取的用户名和密码。" }
        ],
        formConfigList: [
          {
            label: "登录号：",
            value: "loginNo",
            type: "input",
            disabled: false,
            width: "50%",
            maxlength: 20,
            rule: {
              required: false,
              message: "请输入登录号",
              trigger: "blur"
            }
          },
          {
            label: "密码：",
            value: "loginPwd",
            type: "slot",
            slotName: "loginPwd",
            disabled: false,
            rule: {
              required: false,
              message: "请输入密码",
              trigger: "blur"
            }
          },
        ]
      },
      {
        title: "投资项目统一代码",
        name: "2",
        icon: "",
        tipsList: [
          { text: "（1）若“项目类别关联代码”选择“固定资产投资项目”，则“投资项目统一代码”为必填，该数据可以在《湖北省投资和重大项目智慧应用平台（暨湖北省工程建设项目审批管理系统）》 （https://tzxm.hubei.gov.cn/xxgk）上查询，若项目在《湖北省投资和重大项目智慧应用平台（暨湖北省工程建设项目审批管理系统）》上有记录，则交易人在该网站上获得的项目代码，即为“投资项目统一代码”。" },
        ],
        formConfigList: [
          {
            label: "项目类别关联代码：",
            value: "relateCode",
            type: "select",
            required: true,
            width: "50%",
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
            clearable: true,
            optionData: [
              { name: "无", value: "0" },
              { name: "固定资产投资项目", value: "1" },
            ]
          },
          {
            label: "投资项目统一代码：",
            value: "investProjectCode",
            type: "slot",
            slotName: "investProjectCode",
            width: "50%",
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
        ]
      },
      {
        title: "行业代码",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "项目行业门类：",
            type: "select",
            value: "industryClass",
            placeholder: "请输入",
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201610191711290723"
            },
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
          {
            label: "项目行业分类：",
            value: "industryCode",
            type: "select",
            placeholder: "请输入",
            width: "50%",
            required: true,
            queryParams: {
            },
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
        ]
      },
      {
        title: "项目类型",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "项目名称：",
            value: "prjName",
            type: "input",
            required: true,
            placeholder: "请输入",
            width: "100%",
            maxlength: 150,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            type: "select",
            label: "行政监督部门：",
            value: "regulators",
            placeholder: "请输入",
            queryParams: {
              url: "/regulatorsCombobox",
              processType: "201512011001350003",
            },
            required: true,
            rule: {
              required: true,
              message: "该输入项不能为空",
              trigger: "change"
            },
          },
        ]
      },
    ];
  }
  // 报建类项目登记 建设信息
  static biddingInformation() {
    return [
      {
        title: "建设方（甲方）变更/总包单位项目",
        name: "1",
        icon: "",
        tipsList: [
          { text: "建设方（甲方）变更/总包单位项目登记时，请选择原建设方项目登记的项目，并完善项目登记信息，信息完善后须提交到相关监管部门进行核验。" }
        ],
        formConfigList: [

          {
            label: "项目名称：",
            value: "firstConstructionPrjName",
            type: "slot",
            slotName: "firstConstructionPrjName",
            width: "100%",
          },
          {
            label: "原建设方（甲方）项目编号：",
            value: "firstConstructionNo",
            type: "input",
            disabled: true,
            required: true,
            rule: {
              required: false,
              message: "该输入项不能为空",
              trigger: "blur"
            },
          },
          {
            label: "招标人变更类型：",
            type: "select",
            value: "tenderCorpChangeType",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201607071721585823"
            },
          },
        ]
      },
      {
        title: "现建设单位信息",
        name: "2",
        icon: "",
        formConfigList: [
          {
            label: "现建设单位名称：",
            value: "buildCorpName",
            type: "input",
            disabled: true,
          },
          {
            label: "现建设单位组织机构代码：",
            value: "buildCorpCode",
            type: "input",
            disabled: true,
          },
          {
            label: "现建设单位地址：",
            value: "buildCorpAddress",
            type: "input",
            disabled: true,
          },
          {
            label: "现建设单位法定代表人：",
            value: "buildCorpLegal",
            type: "input",
            maxlength: 20,
          },
          {
            label: "现建设单位单位性质：",
            value: "buildCorpProperty",
            type: "input",
            disabled: true,
          },
          {
            label: "现建设单位联系人：",
            value: "buildCorpLinkMan",
            type: "input",
            maxlength: 20,
          },
          {
            label: "现建设单位联系人电话：",
            value: "buildCorpLinkTel",
            type: "input",
            maxlength: 20,
          },
          {
            label: "现建设单位联系人手机：",
            value: "buildCorpLinkMobile",
            type: "input",
            rule: [
              {
                pattern: /^(1[0-9][0-9]|14[0-9]|15[0-9]|18[0-9])\d{8}$/,
                message: "输入的手机号码不正确！",
              },
            ],
          },
          {
            label: "现建设单位邮编：",
            value: "buildCorpPostalCode",
            type: "input",
            disabled: true,
          },
          {
            label: "现建设单位传真：",
            value: "buildCorpFax",
            type: "input",
            maxlength: 30,
          },
          {
            label: "建设单位电子邮件：",
            value: "buildCorpEMail",
            type: "input",
            maxlength: 30,
          },
        ]
      },
    ];
  }
  // 报建类项目登记 项目基本信息
  static basicProjectInformation() {
    return [
      {
        title: "项目基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "项目地点：",
            value: "prjAddress",
            type: "input",
            width: "50%",
            maxlength: 800,
          },
          {
            type: "select",
            label: "项目类别：",
            value: "prjLargeClass",
            clearable: true,
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/engineeringCombobox",
              parentId: "0"
            }
          },
          {
            type: "select",
            label: "项目小类：",
            value: "prjCategory",
            clearable: true,
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/engineeringCombobox",
              parentId: ""
            }
          },
          {
            label: "立项文号：",
            value: "noteNumber",
            type: "input",
            width: "50%",
            maxlength: 30,
          },
          {
            label: "立项级别：",
            type: "select",
            value: "approveLevel",
            width: "50%",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201509241722250016"
            },
          },
          {
            label: "立项形式：",
            type: "select",
            value: "approveType",
            width: "50%",
            placeholder: "请输入",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201509241722460017"
            },
          },
          {
            label: "批准单位：",
            value: "approveUnit",
            type: "input",
            width: "50%",
            maxlength: 40,
          },
          {
            label: "批准投资总额（万元）：",
            value: "totalInvestment",
            type: "slot",
            slotName: "totalInvestment",
            width: "50%",
            rule: {
              required: false,
              message: "请输入批准投资总额",
              trigger: "blur"
            }
          },
          {
            label: "本年度投资计划（万元）：",
            value: "investmentPlanThisYear",
            type: "slot",
            slotName: "investmentPlanThisYear",
            width: "50%",
            rule: {
              required: false,
              message: "请输入本年度投资计划",
              trigger: "blur"
            }
          },
          {
            label: "国有盈利性投资（万元）：",
            value: "stateProfitInvestment",
            type: "slot",
            slotName: "stateProfitInvestment",
            width: "50%",
            rule: {
              required: false,
              message: "请输入国有盈利性投资",
              trigger: "blur"
            }
          },
          {
            label: "国有非盈利性投资（万元）：",
            value: "stateNonprofitInvestment",
            type: "slot",
            slotName: "stateNonprofitInvestment",
            width: "50%",
            rule: {
              required: false,
              message: "请输入国有非盈利性投资",
              trigger: "blur"
            }
          },
          {
            label: "非国有投资（万元）：",
            value: "nonstateInvestment",
            type: "slot",
            slotName: "nonstateInvestment",
            width: "50%",
            rule: {
              required: false,
              message: "请输入非国有投资",
              trigger: "blur"
            }
          },
          {
            label: "外资（万元）：",
            value: "foreignInvestment",
            type: "slot",
            slotName: "foreignInvestment",
            width: "50%",
            rule: {
              required: false,
              message: "请输入外资",
              trigger: "blur"
            }
          },
        ]
      },
    ];
  }
  // 报建类项目登记 工程概况
  static projectOverview() {
    return [
      {
        title: "工程概况",
        tipsList: [
          { text: "仅建设工程类项目须填写！" }
        ],
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "工程规模：",
            value: "projectScale",
            type: "input",
            width: "50%",
            maxlength: 800,
          },
          {
            label: "项目性质：",
            type: "select",
            value: "constructionType",
            placeholder: "请输入",
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201509241722580018"
            },
          },
          {
            label: "项目等级：",
            type: "select",
            value: "constructionGrade",
            placeholder: "请输入",
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201509241723100019"
            },
          },
          {
            label: "重点工程：",
            type: "select",
            value: "isKeyProject",
            placeholder: "请输入",
            width: "50%",
            queryParams: {
              url: "/dataDictionaryEntries/DictionaryCombobox",
              zdid: "201509241723190020"
            },
          },
          {
            label: "规划建筑层数32层以下：",
            tip: "（栋数）",
            value: "layersFollowingThirtyTwo",
            type: "input",
            width: "50%",
            maxlength: 10,
          },
          {
            label: "规划建筑层数32层（含）以上：",
            tip: "（栋数）",
            value: "layersAboveThirtyTwo",
            type: "input",
            width: "50%",
            maxlength: 10,
          },
          {
            label: "深基坑深度9米以下：",
            tip: "（栋数）",
            value: "depthFollowingNine",
            type: "input",
            width: "50%",
            maxlength: 10,
          },
          {
            label: "深基坑深度9米（含）以上：",
            tip: "（栋数）",
            value: "depthAboveNine",
            type: "input",
            width: "50%",
            maxlength: 10,
          },
          {
            label: "建筑高度100米以下：",
            tip: "（栋数）",
            value: "heightFollowingOneHundred",
            type: "input",
            width: "50%",
            maxlength: 10,
          },
          {
            label: "建筑高度100米（含）以上：",
            tip: "（栋数）",
            value: "heightAboveOneHundred",
            type: "input",
            width: "50%",
            maxlength: 10,
          },
          {
            label: "公共建筑跨度30米以下：",
            value: "spanFollowingThirtyTwo",
            tip: "（厂房、公共设施）（栋数）",
            type: "input",
            width: "50%",
            maxlength: 10,
          },
          {
            label: "公共建筑跨度30米（含）以上：",
            value: "spanAboveThirtyTwo",
            tip: "（厂房、公共设施）（栋数）",
            type: "input",
            width: "50%",
            maxlength: 10,
          },
          {
            label: "是否房地产开发：",
            value: "isRealEstateProject",
            type: "select",
            clearable: true,
            width: "50%",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ]
          },
          {
            label: "是否工业项目：",
            value: "isIndustryProject",
            type: "select",
            clearable: true,
            width: "50%",
            optionData: [
              { name: "否", value: "0" },
              { name: "是", value: "1" },
            ]
          },
        ]
      },
    ];
  }
  // 报建类项目登记 其他信息
  static otherInformation() {
    return [
      {
        title: "备注",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "备注信息：",
            value: "description",
            type: "textarea",
            width: "100%",
            class: "formTextarea",
            maxlength: 800,
            tip: "（最多可填800个汉字）",
            disabled: false
          }
        ]
      },
      {
        title: "核验意见",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "核验记录：",
            type: "slot",
            class: "list",
            slotName: "auditBtn",
          },
        ]
      },
    ];
  }
}
